import {Button} from '@wandb/components';
import React from 'react';

import {
  makeCheckoutCommand,
  makeCloneCommand,
  makeExecuteCommand,
} from '../../components/ReproduceRun/useRunReproduceSteps';
import {type RunOverviewCommandItems_RunFragment as RunWithCommandItems} from '../../generated/graphql';
import {RunOverviewItem} from './RunOverviewItem';

type RunOverviewCommandItemsProps = {
  onShowReproduceDrawer(e: unknown): void;
  run: RunWithCommandItems;
};

export function RunOverviewCommandItems({
  onShowReproduceDrawer,
  run,
}: RunOverviewCommandItemsProps) {
  const {runInfo} = run;
  if (!runInfo) {
    return null;
  }

  const stackableControls = runInfo.program ? (
    <Button variant="ghost" startIcon="info" onPress={onShowReproduceDrawer}>
      Reproduce this run
    </Button>
  ) : null;

  return (
    <>
      {runInfo.git?.remote ? (
        <RunOverviewItem name="Git repository" isCommand isCopyable>
          {makeCloneCommand(runInfo.git.remote)}
        </RunOverviewItem>
      ) : null}
      {runInfo?.git?.commit ? (
        <RunOverviewItem name="Git state" isCommand isCopyable>
          {makeCheckoutCommand(runInfo.git.commit, run.displayName ?? null)}
        </RunOverviewItem>
      ) : null}
      {runInfo.executable ? (
        <RunOverviewItem name="Python executable" isCommand isCopyable>
          {runInfo.executable}
        </RunOverviewItem>
      ) : null}
      {runInfo?.program ? (
        <RunOverviewItem
          name="Command"
          isCommand
          isCopyable
          stackableControls={stackableControls}>
          {makeExecuteCommand(runInfo.program, runInfo.args)}
        </RunOverviewItem>
      ) : null}
    </>
  );
}
